import { render, staticRenderFns } from "./ModalListVoice.vue?vue&type=template&id=9f6219c4&"
import script from "./ModalListVoice.vue?vue&type=script&lang=js&"
export * from "./ModalListVoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports